import React from 'react';
import useInitAmplitudeData from '@src/Services/Amplitude/hooks/useInitAmplitudeData';

const InitTrackerUser = () => {
  useInitAmplitudeData();
  return <></>;
};

export default React.memo(InitTrackerUser);
